<script lang="ts">
	import type { NumberRange, SearchFieldProps } from 'utility/search-fields'
	import type { i18n } from 'types/common'

	import Pin from './Pin.svelte'
	import YearInput from '@isoftdata/svelte-year-input'
	import EditModeControls from './EditModeControls.svelte'
	import { getContext } from 'svelte'

	interface Props extends SearchFieldProps<NumberRange> {
		id: string
		label?: string
		value?: NumberRange
	}

	let {
		id,
		label = '',
		inEditMode,
		searchField,
		disabled = false,
		value = $bindable({ from: null, to: null }),
		pinnedSearchFields,
		selectedSearchFieldsKeys,
		change,
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<EditModeControls
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
	{searchField}
	{inEditMode}
>
	<label
		class="col-form-label pb-0"
		for={id}
		>{label}
		<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
	</label>
	<div class="row">
		<div class="col-12 col-md-6">
			<YearInput
				{id}
				label={translate('common:from', 'From')}
				disabled={disabled || inEditMode}
				value={value.from}
				change={newVal => {
					value.from = newVal
					change?.({ field: searchField, value: { from: value.from, to: value.to } })
				}}
			/>
		</div>
		<div class="col-12 col-md-6">
			<YearInput
				id="{searchField.key}-to"
				label={translate('common:to', 'To')}
				disabled={disabled || inEditMode}
				value={value.to}
				change={newVal => {
					value.to = newVal
					change?.({ field: searchField, value: { from: value.from, to: value.to } })
				}}
			/>
		</div>
	</div>
</EditModeControls>
